<mat-tab-group [selectedIndex]="selected.value" (selectedIndexChange)="selectedIndexChange($event)"
    [ngClass]="{'childTabs': isChildTabs, 'grandchildTab': isGrandchildTab, 'capitalize': transformLabelsToTitleCase}" [ngStyle]="{'height': height + 'px'}">
    <mat-tab  #stuff *ngFor="let tab of tabLabels; let index = index" label="{{tab | translate}}"
        [disabled]="checkDisabled(tab) || locked">

    </mat-tab>
</mat-tab-group>